const NONCE_RELOAD_GUARD_KEY = 'acchub_portal_nonce_reload_pending';

const NONCE_EXPIRED_CODES = new Set(['rest_cookie_invalid_nonce', 'invalid_nonce']);

export const extractWpRestErrorCode = (data: unknown): string | null => {
  if (!data || typeof data !== 'object') {
    return null;
  }
  const o = data as Record<string, unknown>;
  if (typeof o.code === 'string' && o.code.length > 0) {
    return o.code;
  }
  const nested = o.data;
  if (nested && typeof nested === 'object') {
    const d = nested as Record<string, unknown>;
    if (typeof d.code === 'string' && d.code.length > 0) {
      return d.code;
    }
  }
  return null;
};

export const isNonceExpiredErrorCode = (code: string): boolean => NONCE_EXPIRED_CODES.has(code);

/**
 * Wraps fetch for REST calls that use X-WP-Nonce: reloads once when WP reports a stale nonce
 * so bootstrap gets a fresh token. Clears the one-shot guard after any successful response.
 */
export const fetchWithNonce = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const response = await fetch(input, init);
  if (response.ok) {
    try {
      sessionStorage.removeItem(NONCE_RELOAD_GUARD_KEY);
    } catch {
      /* storage blocked */
    }
    return response;
  }

  let parsedCode: string | null = null;
  try {
    const data = (await response.clone().json()) as unknown;
    parsedCode = extractWpRestErrorCode(data);
  } catch {
    /* not JSON */
  }

  if (
    parsedCode !== null &&
    isNonceExpiredErrorCode(parsedCode) &&
    (response.status === 401 || response.status === 403)
  ) {
    try {
      if (sessionStorage.getItem(NONCE_RELOAD_GUARD_KEY) !== '1') {
        sessionStorage.setItem(NONCE_RELOAD_GUARD_KEY, '1');
        window.location.reload();
        return new Promise(() => {});
      }
    } catch {
      /* storage blocked — fall through */
    }
  }

  return response;
};
